import type { PrevisaoNaoFirmeDia } from "../../api/types";
import { fmtBRL } from "../../utils/formatters";

/**
 * 16/10 ([SYNC-066]): saídas CP com previsão EMPURRADA (ex.: títulos de sócios
 * a 31/12). Só marca — o valor continua no dia da previsão; a nota diz que a
 * data não é firme. Sem marcas, não renderiza nada.
 */
export function PrevisaoNaoFirmeNotas({ marcas }: { marcas?: PrevisaoNaoFirmeDia[] | null }) {
  if (!marcas?.length) return null;
  return (
    <>
      {marcas.map((m) => (
        <p
          key={`${m.data}-${m.rotulo}`}
          className="text-[11px] text-amber-300/80 mt-2 leading-relaxed max-w-3xl"
          data-testid="fluxo-previsao-nao-firme"
          title={m.fonte ?? undefined}
        >
          {`${m.data.slice(8, 10)}/${m.data.slice(5, 7)}`}: {fmtBRL(m.valor)} em {m.n}{" "}
          {m.n === 1 ? "título" : "títulos"} com {m.rotulo} — o valor fica no dia da
          previsão, mas não é a data real de pagamento.
        </p>
      ))}
    </>
  );
}
